import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import 'dayjs/locale/en';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import minMax from 'dayjs/plugin/minMax';
import weekday from 'dayjs/plugin/weekday';
import duration from 'dayjs/plugin/duration';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isTomorrow from 'dayjs/plugin/isTomorrow';

dayjs.locale('ko');
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(minMax);
dayjs.extend(weekday);
dayjs.extend(duration);
dayjs.extend(advancedFormat);
dayjs.extend(isTomorrow);

class DateUtil {
    constructor() {
        this.timeZone = 'Asia/Seoul';
        this.language = 'ko';
        this.FORMAT = {
            DEFAULT_FORMAT: 'YYYY-MM-DD HH:mm',
            FULL_FORMAT: 'YYYY-MM-DD HH:mm:ss',
            DATE_FORMAT: 'YYYY-MM-DD',
            DOT_DATE_FORMAT: 'YYYY.MM.DD',
            TIME_FORMAT: 'HH:mm',
        };
    }

    getLocalTimeZone() {
        return dayjs.tz.guess();
    }

    setTimeZone(zone) {
        this.timeZone = zone;
    }

    getTimeZoneDate(date, format) {
        if (date === null) {
            return '';
        }

        return dayjs(date).tz('UTC', true).tz(this.timeZone).format(format);
    }

    convertTimeZoneToUTC(date) {
        return dayjs(date).tz('UTC', true);
    };
}

export const DATE_UTIL = new DateUtil();
